import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { type FC, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { ADD_POSITION_LABEL, ADD_POSITION_PATH, TABLET } from '@app/constants';
import { useNewUserAccessRights, useWindowSize } from '@app/hooks';

export const PositionsPageHeader: FC = () => {
  const { innerWidth, isMobile } = useWindowSize();
  const {
    userAccessRights: { Positions },
  } = useNewUserAccessRights();

  const hasUserRightToCreatePosition = useMemo(
    () => Positions?.IsCreate,
    [Positions]
  );
  const hasUserRightToViewPositions = useMemo(
    () => Positions?.IsOn,
    [Positions]
  );

  const label = useMemo(
    () => (innerWidth <= TABLET ? '' : ADD_POSITION_LABEL),
    [innerWidth]
  );

  if (!hasUserRightToViewPositions && !hasUserRightToCreatePosition) {
    return null;
  }

  if (!hasUserRightToCreatePosition) {
    return null;
  }

  return (
    <Link to={ADD_POSITION_PATH}>
      <Button
        className={isMobile ? 'full-width' : ''}
        type="primary"
        icon={<PlusOutlined />}
        data-testid="add-position"
      >
        {label}
      </Button>
    </Link>
  );
};
